export const PAGE_NAME = 'Tracker';
